import type { SVGProps } from 'react'
const SvgSyPaperDownload = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillRule="evenodd"
			d="M8.084 2.012C5.62 2.012 3.5 3.999 3.5 6.49v10.74c0 2.556 2.015 4.636 4.584 4.636h7.988c2.504 0 4.48-2.171 4.48-4.636V8.037a.75.75 0 0 0-.208-.52l-5.067-5.275a.75.75 0 0 0-.54-.23zm0 1.5h6.332l4.637 4.828v8.889c0 1.654-1.364 3.136-2.98 3.136h-7.99C6.301 20.365 5 19.024 5 17.23V6.49c0-1.629 1.43-2.978 3.084-2.978"
			clipRule="evenodd"
		/>
		<path d="M14.473 2a.75.75 0 0 0-.75.75v2.91a3.336 3.336 0 0 0 3.318 3.324l1.838.002h.637c.161 0 .184.004.33-.006a.75.75 0 0 0 .699-.796.75.75 0 0 0-.797-.7c.1-.006-.08.002-.238.002h-.631c-.512 0-1.176 0-1.834-.002a1.814 1.814 0 0 1-1.822-1.824V2.75a.75.75 0 0 0-.75-.75" />
		<path
			fillRule="evenodd"
			d="M12.39 9.44a.75.75 0 0 0-1.5 0v4.758l-1.556-1.564a.75.75 0 0 0-1.063 1.058l2.838 2.851a.75.75 0 0 0 1.067-.004l2.835-2.847a.75.75 0 1 0-1.063-1.058l-1.557 1.564z"
			clipRule="evenodd"
			opacity={0.4}
		/>
	</svg>
)
export default SvgSyPaperDownload
